import { Text, PrimaryButton, Image } from '@fluentui/react';
import { useFileBrowserStore } from '@/hooks';

export function LoginScreen() {
  const { auth, login } = useFileBrowserStore();

  return (
    <div className="login-screen">
      <div className="login-content">
        <div className="login-logo">
          <Image src="https://crgglobalinc.com/en/assets/img/logo-dark.svg" alt="CRG Global Inc" />
        </div>

        <Text variant="xLarge" className="login-title">
          CRG FileSpace
        </Text>

        <Text className="login-description">
          Access and manage shared files in the cloud. Sign in with your organization account to get
          started.
        </Text>

        {auth.error && <Text className="login-error">{auth.error}</Text>}

        <PrimaryButton
          text={auth.isLoading ? 'Signing in' : 'Sign in'}
          onClick={login}
          disabled={auth.isLoading}
          className="login-button"
        />
      </div>
    </div>
  );
}
